import React from 'react';
import PropTypes from 'prop-types';

const GroupTeacherName = ({ name }) => {
  return (
    <div className="group-teacher-name active-card small-card text-primary-bold">
      {name}
    </div>
  );
};

GroupTeacherName.propTypes = {
  name: PropTypes.string
};

export default GroupTeacherName;



// WEBPACK FOOTER //
// ./src/pages/pointofsale/modules/groupTeacher/component/GroupTeacherName.js